import { render, staticRenderFns } from "./vueSwiper.vue?vue&type=template&id=60a34dd6&scoped=true&"
import script from "./vueSwiper.vue?vue&type=script&lang=js&"
export * from "./vueSwiper.vue?vue&type=script&lang=js&"
import style0 from "./vueSwiper.vue?vue&type=style&index=0&id=60a34dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a34dd6",
  null
  
)

export default component.exports